import { Link, useParams } from "react-router-dom";
import { useLocale } from "../../localization/LocaleProvider";
import { useEffect, useState } from "react";
import { useApi } from "../../context/ApiProvider";
import moment from "moment";
import Card from "../Helpers/Card";
import ActivityIndicator from "../Helpers/ActivityIndicator";
import { Formik } from "formik";

export default function ClientMembers() {

  const { clientId } = useParams();
  const { translate } = useLocale();
  const Api = useApi();

  const [members, setMembers] = useState([]);
  const [isLoadingMembers, setIsLoadingMembers] = useState(false);
  const [checked, setChecked] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (clientId)
      fetchMembers();
  }, [clientId]);

  const fetchMembers = async () => {

    setIsLoadingMembers(true);
    Api.get(`/rolf/clients/${clientId}/members`).then(result => {
      setMembers(result);
    }).catch(error => {
      console.log(error);
    }).finally(() => {
      setIsLoadingMembers(false);
    })
  }

  const toggleMember = (id, check) => {
    if (check)
      setChecked((prev) => [...prev, id]);
    else
      setChecked((prev) => prev.filter(e => e !== id));
  }

  const confirmUnregister = () => {
    if (window.confirm(translate("Are you sure you want to unregister the selected members?"))) {
      unregisterMembers();
    }
  }

  const unregisterMembers = () => {
    setIsSubmitting(true);
    Api.post(`/rolf/clients/${clientId}/members/unregister`, { members: checked }).then(result => {
      setChecked([]);
      fetchMembers();
    }).catch(error => {
      console.log(error);
    }).finally(() => {
      setIsSubmitting(false)
    })
  }

  return (
    <div className="grid-container">
      <section className="grow">
        <h4>{translate("Members")}</h4>

        {isLoadingMembers && <p>{translate("Loading members...")}</p>}
        {!isLoadingMembers && members && members.length === 0 && <p>{translate("No members found")}</p>}
        {members && members.length > 0 ?
          <>

            <table>
              <thead>
                <tr>
                  <th>{translate("Name")}</th>
                  <th>{translate("Organisation")}</th>
                  <th>{translate("Last login")}</th>
                  <th>
                    <input type="checkbox" onClick={(v) => { v.target.checked ? setChecked(members.filter(member => member.clientCount == 0 || !member.clientCount).map(member => member.ID)) : setChecked([]) }} />
                  </th>
                </tr>
              </thead>
              <tbody>
                {members?.map(member => {
                  return (
                    <tr key={member.ID} className="">
                      <td>
                        <Link to={`/clients/${clientId}/members/${member.ID}`} className={member.active == 0 ? 'inactive' : ''}>{member.firstName} {member.lastName}</Link><br />
                      </td>
                      <td>
                        {member.organisations?.map(org => {
                          if(!org.permissions) org.permissions = []; //Säkerställer att permissions är en array
                          return (
                            <div key={org.ID}>
                              <span className="meta">{org.clientName}</span> / <Link to={`/clients/${clientId}/organisations/${org.ID}`} className="meta">{org.name}</Link> {org.permissions?.includes("owner") ? <i className="fa fa-users meta" aria-hidden="true" title="Owner"></i> : ""}
                            </div>
                          )
                        })}
                      </td>
                      <td>
                        {member.lastLogin ? moment.unix(member.lastLogin).fromNow() : translate("Never")}
                      </td>

                      <td>
                        {member.clientCount > 0 ? null :
                          <input type="checkbox" checked={checked.includes(member.ID)} onChange={(v) => toggleMember(member.ID, v.target.checked)} />
                        }
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </>
          : null}
      </section>
      <section>
        <h4>{translate("Actions")}</h4>
        <Card>
          <Formik>
            <button type="submit" disabled={isSubmitting}
              onClick={confirmUnregister} className="danger"
            >{translate("Unregister")} {isSubmitting && <ActivityIndicator />}</button>
          </Formik>

          <p>
            <strong>{translate("Unregister")}:</strong> {translate("Unregistering a user will remove all data associated with the user")}
          </p>

        </Card>
      </section>

    </div >
  )

}